import api from './client';

export interface Equipment {
  id: number;
  inventory_number: string;
  name: string;
  brand: string | null;
  model: string | null;
  year: number | null;
  purchase_cost: number | null;
  purchase_source: string | null;
  purchase_date: string | null;
  issue_date: string | null;
  receipt_url: string | null;
  type_id: number | null;
  department_id: number | null;
  type: { id: number; name: string } | null;
  department: { id: number; name: string } | null;
  workplaces: { id: number; name: string }[];
  category: string;
  status: string;
  assigned_employee_id: number | null;
  assigned_employee: { id: number; first_name: string; last_name: string } | null;
}

export interface EquipmentFilters {
  type_id?: number;
  department_id?: number;
  category?: string;
  search?: string;
}

export interface EquipmentPayload {
  inventory_number: string;
  name: string;
  brand?: string | null;
  model?: string | null;
  year?: number | null;
  purchase_cost?: number | null;
  purchase_source?: string | null;
  purchase_date?: string | null;
  issue_date?: string | null;
  receipt_url?: string | null;
  type_id?: number | null;
  department_id?: number | null;
  workplace_ids?: number[];
  category?: string;
  status?: string;
  assigned_employee_id?: number | null;
}

export const getEquipment = (filters?: EquipmentFilters) =>
  api.get<Equipment[]>('/equipment', { params: filters }).then(r => r.data);

export const createEquipment = (data: EquipmentPayload) =>
  api.post<Equipment>('/equipment', data).then(r => r.data);

export const updateEquipment = (id: number, data: Partial<EquipmentPayload>) =>
  api.put<Equipment>(`/equipment/${id}`, data).then(r => r.data);

export const deleteEquipment = (id: number) =>
  api.delete(`/equipment/${id}`);
